import * as actionTypes from "../actionTypes";

const initialState = {
  carriers: [],
  inactiveCarriers: [],
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_CARRIERS:
      return {
        ...state,
        carriers: action.payload,
      };
    case actionTypes.SET_INACTIVE_CARRIERS:
      return {
        ...state,
        inactiveCarriers: action.payload,
      };
    default:
      return state;
  }
}

export default reducer;
